import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheInterceptor, MockInterceptor, RequestInterceptor, ResponseInterceptor } from '@api/interceptors';

/**
 * HTTP interceptor chain configuration for the application.
 *
 * @remarks
 * **Execution Order:**
 * 1. CacheInterceptor - Response caching
 * 2. RequestInterceptor - Request modifications (auth headers, etc.)
 * 3. ResponseInterceptor - Response processing
 * 4. MockInterceptor - Mock data for development/testing
 *
 * @example
 * ```
 * // In app.config.ts
 * import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
 * import { httpInterceptorProviders } from '@api/interceptors';
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideHttpClient(withInterceptorsFromDi()),
 *     httpInterceptorProviders
 *   ]
 * };
 * ```
 */
export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CacheInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ResponseInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MockInterceptor,
    multi: true,
  },
];
